"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.corpusRegistry = exports.functionRegistry = void 0;
exports.functionRegistry = new Map();
exports.corpusRegistry = new Map();
